import { useEffect, useState } from 'react';
import { UnfinishedEntitiesReportOrdering } from '../enum/ReportTableOrders';
import { setUnfinishedEntitiesFilters } from '../../store/slices/reportsSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { unfinishedEntitiesFiltersSelector } from '../../store/selectors/reportsSelectors';
import { unfinishedEntitiesOrderingSelector } from '../../store/selectors/coreOrderingSelectors';
import { getUnfinishedEntitiesOrdering } from '../../store/thunks/core/coreOrderingThunks';
import { initPaging } from '../../core/types/coreTypes';

export const useUnfinishedEntitiesDefaultOrdering = (shouldFetch = true) => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(unfinishedEntitiesFiltersSelector);
  const ordering = useAppSelector(unfinishedEntitiesOrderingSelector);
  const [defaultOrder, setDefaultOrder] = useState<number | null>(null);

  useEffect(() => {
    !ordering.length && shouldFetch && dispatch(getUnfinishedEntitiesOrdering());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!filters?.order?.field) {
      const defaultOrdering = ordering.find((el) => el.label === UnfinishedEntitiesReportOrdering.CreationDate)?.value;
      if (defaultOrdering) {
        setDefaultOrder(defaultOrdering);
        dispatch(setUnfinishedEntitiesFilters({ ...filters, order: { field: defaultOrdering, isAsc: true } }));
      }
    }
    // eslint-disable-next-line
  }, [ordering]);

  return {
    ...initPaging,
    order: defaultOrder ? { field: defaultOrder, isAsc: true } : filters?.order,
  };
};
